<template>
  <button class="back-button" type="button" title="Вернуться назад" />
</template>

<style scoped lang="scss">
  @import '@/assets/theme/default/global/mixin';

  .back-button {
    @include area();
    @include opacity(0.2);
    $size: 40px;
    position: fixed;
    border-radius: 50%;
    background: linear-gradient(89.88deg, #0178c8 0.1%, #01b1aa 99.9%);
    bottom: 30px;
    width: $size;
    height: $size;
    border: 0;
    padding: 0;
    margin-left: 30px;

    &:before {
      $offset: 5px;
      content: '';
      position: absolute;
      background-color: #fff;
      background-image: url(~@/assets/images/svg/arrow_back.svg);
      background-repeat: no-repeat;
      background-size: calc(#{$size} - 40%);
      background-position: 50%;
      border-radius: inherit;
      width: calc(100% - #{$offset});
      height: calc(100% - #{$offset});
      top: calc($offset / 2);
      left: calc($offset / 2);
    }

    &:hover {
      opacity: 1;
    }
  }
</style>
